<ion-grid>
  <ion-row
    [class]="{ 'ion-align-items-center': !alignTop, 'ion-align-items-top': alignTop }"
    class="ion-justify-content-center"
  >
    <ion-col
      size="12"
      class="ion-text-center ion-margin"
    >
      <div
        *ngIf="notFoundImage && isImageOnTop"
        class="flex-center no-results"
      >
        <ion-img
          src="assets/img/mable/{{ notFoundImage }}.svg"
          alt="no results"
        ></ion-img>
      </div>

      <mable-heading
        *ngIf="isHeading"
        heading="h3"
        class="text-center"
        color="grey-500"
      >
        {{ cHeading }}</mable-heading
      >
      <ion-text
        class="body-regular"
        color="grey-500"
      >
        <p class="ion-margin-horizontal">{{ cBody }}</p>
      </ion-text>
      <mable-button
        *ngIf="isActionCleanSlate"
        category="orange-500"
        class="action"
        (onClick)="emitEvent()"
        >{{ cActionText }}
      </mable-button>
      <ng-content></ng-content>
      <div
        *ngIf="notFoundImage && !isImageOnTop"
        class="flex-center no-results"
      >
        <ion-img
          src="assets/img/mable/{{ notFoundImage }}.svg"
          alt="no results"
        ></ion-img>
      </div>
      <div
        class="background"
        [ngClass]="category"
        *ngIf="category"
      ></div>
    </ion-col>
  </ion-row>
</ion-grid>
